import { useQuery } from '@apollo/client';
import React from 'react';
import { GET_DEALER } from '../schemas/DealerLocationSchema';
import { DEALER_GATEWAY_URL, dealerClient } from '../constants/environment';
import { DealerLocationData } from '../types';

interface QueryResult {
  dealerById: DealerLocationData;
}

// Specific hook to get Dealer data from SCS
const useGetDealerDetails = (dealerId: string | null) => {
  const { data, loading, error } = useQuery<QueryResult>(GET_DEALER, {
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip: !dealerId,
    variables: {
      dealerId,
    },
    context: {
      headers: { clientid: 'wv2ybzheub' },
    },
    client: dealerClient,
  });
  const dealerInfo = data?.dealerById;
  return { dealerInfo, isLoadingDealer: loading };
};

export default useGetDealerDetails;
